<ngx-spinner type="none">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</ngx-spinner>
